module.exports = __webpack_public_path__ + "static/fast-skeleton-inline-svg-e7efea03ea50c59ff5348254f4f97568.png";